export enum CountryAddressField {
  Address = 'address',
  Address2 = 'address2',
  City = 'city',
  State = 'state',
  PostalCode = 'postalCode',
  Phone = 'phone',
}

export type TAddressLabels = Record<CountryAddressField, string>;

export type TState = {
  name: string;
  abbreviation: string;
};

export type TCountry = {
  id: number;
  name: string;
  code: string;
  image: string;
  states: TState[];
  labels: TAddressLabels;
  validation: {
    optionalFields: CountryAddressField[];
  };
};
